/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable indent */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { localString } from '../../localization/localString';

import { Creators } from '../../views/Layout/store';
// import { navs } from './routes';
import {
  Container,
  NavItem,
  Scroll,
  Toggle,
  Icon,
  Image,
  MultiLevelNavHeaderContainer,
  MultiLevelNavHeader,
  BreadCrumb
} from './Sidenav.styles';

import DropArrow from '../../assets/icons/layout/dropdownarrow.svg';
import RenderSubNavs from './RenderSubNavs';
import RenderMultiLevelNav from './RenderMultiLevelNav';
import DynamicSVGIcon from '../Common/DynamicSVGIcon';
import Hamburger from '../../assets/icons/layout/hamburger.svg';
import { getStringLocale } from '../../constants/language';

const SideNav = ({ sideNavRef }) => {
  const { language } = useSelector((state) => state.configData);
  const { menu, showSideNav, activeMultiLevelNav } = useSelector(
    (state) => state.home
  );
  const { localeStrings } = useSelector((state) => state.localeStrings);

  const string = localString[language];

  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(Creators.setShowSideNav({ showSideNav: !showSideNav }));
  };

  const deleteLastItem = () => {
    if (activeMultiLevelNav.length < 2) {
      dispatch(Creators.setActiveMultiLevelMenu([]));
    } else {
      const newArray = [...activeMultiLevelNav];
      newArray.pop();
      dispatch(Creators.setActiveMultiLevelMenu(newArray));
    }
  };

  return (
    <Container
      ref={sideNavRef}
      active={showSideNav}
      className={`icon ${showSideNav ? '' : 'hidden'}`}
    >
      {/* menu container */}
      <Scroll className={`${showSideNav ? '' : 'hidden'}`}>
        {activeMultiLevelNav &&
        activeMultiLevelNav.length > 0 &&
        showSideNav ? (
          <>
            <MultiLevelNavHeaderContainer onClick={deleteLastItem}>
              <Image>
                <DynamicSVGIcon iconUrl={DropArrow} width='1.4rem' />
              </Image>
              <div>
                <MultiLevelNavHeader>
                  {localeStrings[
                    activeMultiLevelNav[activeMultiLevelNav.length - 1].parent
                      .name
                  ] ||
                    activeMultiLevelNav[activeMultiLevelNav.length - 1].parent
                      .name}
                </MultiLevelNavHeader>
                <BreadCrumb>
                  {
                    activeMultiLevelNav[activeMultiLevelNav.length - 1].parent
                      .Permalink
                  }
                </BreadCrumb>
              </div>
            </MultiLevelNavHeaderContainer>
            {activeMultiLevelNav[activeMultiLevelNav.length - 1].subMenu.map(
              (nav, i) => (
                <RenderMultiLevelNav key={i} {...nav} active={showSideNav} />
              )
            )}
          </>
        ) : (
          menu.map((nav, index) => {
            if (nav.IsLeaf === '0') {
              return (
                <RenderSubNavs
                  parent={nav.Permalink}
                  key={index}
                  {...nav}
                  active={showSideNav}
                  activeIcon={nav.IconActive}
                />
              );
            }
            const Permalink = nav.Permalink || '/home/' + nav.Name;
            return (
              <NavItem
                key={index}
                // make exact true only for home since it is substring for all the routes
                // ['', 'home']
                exact={Permalink.split('/')?.length === 2}
                to={Permalink}
                activeicon={nav.IconActive}
              >
                {/* <Icon className='icon' icon={nav.icon} /> */}
                <Icon className='icon'>
                  <DynamicSVGIcon iconUrl={nav.Icon} width='2rem' />
                </Icon>
                {/* {url(nav.icon)} */}
                {/* <object type='image/svg+xml' data={nav.icon} /> */}
                {showSideNav &&
                  getStringLocale(localeStrings[nav.Name] || nav.Name)}
              </NavItem>
            );
          })
        )}
      </Scroll>
    </Container>
  );
};

export default SideNav;
